(function () {
  'use strict';

  angular
    .module('web2print')
    .directive('cookieBar', cookieBar);

  function cookieBar () {
    const directive = {
      restrict: 'E',
      templateUrl: 'components/shared/cookie-bar/cookie-bar.html',
      controller: CookieBarController,
      controllerAs: 'cookiebar',
      bindToController: true
    };
    return directive;
  }

  CookieBarController.$inject = ['$localStorage'];
  function CookieBarController ($localStorage) {
    const vm = this;
    vm.showCookieBar = true;
    vm.displayCookieBar = displayCookieBar;
    vm.closeCookieBar = closeCookieBar;

    displayCookieBar();

    function displayCookieBar () {
      if ($localStorage.hasApprovedCookies) {
        vm.showCookieBar = false;
      }
    }

    function closeCookieBar () {
      $localStorage.hasApprovedCookies = true;
      vm.showCookieBar = false;
    }
  }

})();
